function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import { h, Component } from 'preact';
import { nanoid } from 'nanoid/non-secure';
var _handleSubmit = /*#__PURE__*/_classPrivateFieldLooseKey("handleSubmit");
var UrlUI = /*#__PURE__*/function (_Component) {
  _inherits(UrlUI, _Component);
  function UrlUI(props) {
    var _this;
    _classCallCheck(this, UrlUI);
    _this = _callSuper(this, UrlUI, [props]);
    _this.form = document.createElement('form');
    Object.defineProperty(_assertThisInitialized(_this), _handleSubmit, {
      writable: true,
      value: function value(ev) {
        ev.preventDefault();
        var addFile = _this.props.addFile;
        var preparedValue = _this.input.value.trim();
        addFile(preparedValue);
      }
    });
    _this.form.id = nanoid();
    return _this;
  }
  _createClass(UrlUI, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.input.value = '';
      this.form.addEventListener('submit', _classPrivateFieldLooseBase(this, _handleSubmit)[_handleSubmit]);
      document.body.appendChild(this.form);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.form.removeEventListener('submit', _classPrivateFieldLooseBase(this, _handleSubmit)[_handleSubmit]);
      document.body.removeChild(this.form);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var i18n = this.props.i18n;
      return h("div", {
        className: "uppy-Url"
      }, h("input", {
        className: "uppy-u-reset uppy-c-textInput uppy-Url-input",
        type: "text",
        "aria-label": i18n('enterUrlToImport'),
        placeholder: i18n('enterUrlToImport'),
        ref: function ref(input) {
          _this2.input = input;
        },
        "data-uppy-super-focusable": true,
        form: this.form.id
      }), h("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Url-importButton",
        type: "submit",
        form: this.form.id
      }, i18n('import')));
    }
  }]);
  return UrlUI;
}(Component);
export default UrlUI;